export default __webpack_public_path__ + "static/media/customer2.946dc549.svg";